import { SideMenu } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/SideMenu/SideMenu';
import { CardHeader } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardHeader/CardHeader';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.module.scss';
import {
    IActiveTab,
    TabsSection,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { tabsArrData } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.utils';
import { TrackedUntrackedAction } from 'components/common/TrackedUntrackedAction/trackedUntrackedAction';
import { ProgramActivityCardStatusSelect } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCardStatusSelect/ProgramActivityCardStatusSelect';
import { CardContent } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/CardContent/CardContent';
import { CardFooter } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardFooter/CardFooter';
import { CustomizedButton } from 'components/common';
import { QueryResponse as CardResponse } from 'api/queries/getMainCard.query';
import React from 'react';
import { Control, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.types';
import { QueryResponse as boardInitResponse } from 'api/queries/getBoardInitLite.query';
import { FieldErrors } from 'react-hook-form/dist/types/errors';
import { cardsDataQueryKey } from 'api/queries/getListFilteredCards.query';

interface Props {
    data: CardResponse;
    activeTab: IActiveTab;
    setValue: UseFormSetValue<IFields>;
    control: Control<IFields, any, IFields>;
    setActiveTab: React.Dispatch<React.SetStateAction<IActiveTab>>;
    watch: UseFormWatch<IFields>;
    boardInit: boardInitResponse | undefined;
    errors: FieldErrors<IFields>;
    handleCardClose: () => void;
    register: UseFormRegister<IFields>;
    queryKeys: string[];
    isCardDirty: boolean;
}

export const ProgramActivityCardDesktop = ({
    data,
    activeTab,
    setValue,
    control,
    setActiveTab,
    watch,
    boardInit,
    errors,
    handleCardClose,
    register,
    queryKeys,
    isCardDirty,
}: Props) => {
    return (
        <>
            <SideMenu
                title={data.title}
                taskId={data.taskId}
                taskVersionHashCode={data.taskVersionHashCode}
                originalStatus={data.originalStatus}
                originalStartDate={data.originalStartDate}
                originalEndDate={data.originalEndDate}
                setValue={setValue}
                category={data.category.name}
                isStatusOrDatesChanged={data.isStatusOrDatesChanged}
            />

            <CardHeader control={control} />
            <div className={classes.tabsWithStatusWrapper}>
                <TabsSection tabs={tabsArrData} activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className={classes.starWrapper}>
                    <TrackedUntrackedAction
                        isTracked={data.isTracked}
                        taskVersionHashCode={data.taskVersionHashCode}
                        invalidateQueriesKey={['getCard', cardsDataQueryKey]}
                        dataTrackId={'card'}
                    />
                    <ProgramActivityCardStatusSelect
                        control={control}
                        category={watch('category')}
                        originalStatus={watch('originalStatus')}
                        isStatusOrDatesChanged={data.isStatusOrDatesChanged}
                    />
                </div>
            </div>
            <CardContent
                activeTab={activeTab}
                boardInit={boardInit}
                setValue={setValue}
                watch={watch}
                control={control}
                errors={errors}
                data={data}
                queryKeys={queryKeys}
                register={register}
            />

            <CardFooter>
                <CustomizedButton
                    size={'large'}
                    color={'secondary'}
                    onClick={handleCardClose}
                    id={'cardModalCloseOrCancelButton'}
                    data-track-id={`button-close-card`}
                >
                    Close
                </CustomizedButton>
                <CustomizedButton
                    type={'submit'}
                    size={'large'}
                    color={'primary'}
                    id={'cardModalSaveButton'}
                    disabled={!isCardDirty}
                    data-track-id={`button-save-card`}
                >
                    Save
                </CustomizedButton>
            </CardFooter>
        </>
    );
};
